import { apiFetch } from "../utils/apiFetch"

export type ProductIndicationTerm = {
  conceptId?: string
  classNumber: number
  subClassNumber: number
  text: string
}

export type ProductIndicationValidationResult = {
  sourceLanguage: string
  productIndications: Array<{
    classNumber: number
    subClassNumber: number
    terms: Array<{
      text: string
      conceptId?: string | null
      harmonized: boolean
    }>
  }>
}

export function searchProductIndications(term: string, language = "en") {
  const params = new URLSearchParams({
    term,
    language
  })

  return apiFetch(`/api/product-indications/terms?${params.toString()}`) as Promise<ProductIndicationTerm[]>
}

export function validateProductIndications(
  terms: ProductIndicationTerm[],
  language = "en"
) {
  return apiFetch("/api/product-indications/validate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ terms, language })
  }) as Promise<ProductIndicationValidationResult>
}
